import { Language } from './App';

export type ClientRepresentation = {
    clientId: string;
    clientName: string | null;
    description: { [key in Language]: string };
    inUse: boolean;
    offlineAccess: boolean;
    userConsentRequired: boolean;
    baseUrl: string;
    consent: any;
}

// New type to handle language-specific descriptions
export type LocalizedClientRepresentation = Omit<ClientRepresentation, 'description'> & { description: string };

export const fetchAccountConsoles = async (language: Language): Promise<LocalizedClientRepresentation[]> => {
    const consoles: ClientRepresentation[] = [
        {
            clientId: "account-console",
            clientName: null,
            description: {
                [Language.CZECH]: "Pracovníci Trask",
                [Language.ENGLISH]: "Trask Employees"
            },
            userConsentRequired: false,
            inUse: false,
            offlineAccess: false,
            baseUrl: "/realms/trask/account/",
            consent: null
        },
        {
            clientId: "account-console",
            clientName: null,
            description: {
                [Language.CZECH]: "Externí uživatelé",
                [Language.ENGLISH]: "External Users"
            },
            userConsentRequired: false,
            inUse: false,
            offlineAccess: false,
            baseUrl: "/realms/extern/account/",
            consent: null
        },
        {
            clientId: "account-console",
            clientName: null,
            description: {
                [Language.CZECH]: "Zákazníci",
                [Language.ENGLISH]: "Customers"
            },
            userConsentRequired: false,
            inUse: false,
            offlineAccess: false,
            baseUrl: "/realms/customers/account/",
            consent: null
        },
    ];

    // Map to LocalizedClientRepresentation, selecting the language-specific description
    return consoles.map(client => ({
        ...client,
        description: client.description[language] // Convert description to a string for the selected language
    }));
};

